import get from 'lodash.get';

export const v3OptOutIsProcessing = (state) => get(state, 'v3OptOutIsProcessing', false);
export const v3OptOutErrorOnSubmit = (state) => get(state, 'v3OptOutErrorOnSubmit', false);
